import ColourRefinementList from '@components/algolia/ColourRefinementList'
import NoOfFilters from '@components/algolia/NoOfFilters/NoOfFilters'
import { Close } from '@components/icons'
import CloseSmall from '@components/icons/CloseSmall'
import { useUI } from '@components/ui'
import { motion } from 'framer-motion'
import { useTranslation } from 'next-i18next'
import { useEffect, useRef } from 'react'
import { ClearRefinements, Stats } from 'react-instantsearch'
import { lock, unlock } from 'tua-body-scroll-lock'
const FilterSidebar = () => {
  const { t } = useTranslation('common')
  const sidebarRef = useRef() as React.MutableRefObject<HTMLDivElement>
  const contentRef = useRef() as React.MutableRefObject<HTMLDivElement>
  const { closeFilterSidebar, displayFilterSidebar } = useUI()

  const resultsCount = () => (
    <Stats
      translations={{
        rootElementText({ nbHits }: any) {
          return `${t('show')} ${nbHits.toLocaleString()} ${t('results')}`
        },
      }}
      className="label text-white"
    />
  )
  useEffect(() => {
    const contentElement = contentRef.current
    contentElement && displayFilterSidebar
      ? lock(contentElement)
      : unlock(contentElement)
  }, [displayFilterSidebar])
  const rootVariants = {
    open: {
      display: 'block',
    },
    closed: {
      display: 'none',
      transition: {
        delay: 0.4,
        when: 'afterChildren',
      },
    },
  }
  const backdropVariants = {
    open: {
      opacity: 1,
      transition: {
        duration: 0.3,
      },
    },
    closed: {
      opacity: 0,
      transition: {
        duration: 0.3,
      },
    },
  }
  const sidebarVariants = {
    open: {
      x: 0,
      transition: {
        duration: 0.4,
      },
    },
    closed: {
      x: 392,
      transition: {
        duration: 0.4,
      },
    },
  }
  return (
    <motion.div
      variants={rootVariants}
      animate={displayFilterSidebar ? 'open' : 'closed'}
      initial={{ display: 'none' }}
      className="fixed inset-0 z-50 box-border h-full w-full outline-none"
    >
      <div className="absolute inset-0 overflow-hidden">
        <motion.div
          onClick={closeFilterSidebar}
          ref={sidebarRef}
          variants={backdropVariants}
          animate={displayFilterSidebar ? 'open' : 'closed'}
          className="fixed inset-0  h-full w-full bg-ui-dark-grey bg-opacity-50"
        ></motion.div>
        <motion.div
          variants={sidebarVariants}
          animate={displayFilterSidebar ? 'open' : 'closed'}
          className="absolute inset-y-0 right-0 flex h-full w-full flex-col bg-white pt-10 md:w-98 md:pt-14"
        >
          <button
            className="absolute top-3 right-3 block md:hidden"
            onClick={closeFilterSidebar}
          >
            <CloseSmall />
          </button>
          <button
            className="absolute top-4 right-6 hidden md:block"
            onClick={closeFilterSidebar}
          >
            <Close />
          </button>
          <div
            ref={contentRef}
            className="flex h-full flex-1 flex-col overflow-y-scroll scrollbar-hide"
          >
            <div className="sticky top-0 flex items-center justify-between bg-white px-4 pb-6 md:px-6">
              <div className="label-large-bold flex items-center gap-3">
                {t('filter')} <NoOfFilters />
              </div>
              <div className="text-body2 font-normal">
                <ClearRefinements
                  translations={{
                    resetButtonText: t('clear-all'),
                  }}
                  className="underline"
                />
              </div>
            </div>
            <div className="h-full">
              <ColourRefinementList />
            </div>
          </div>
          <div className="mt-auto border border-t-ui-grey-25 py-5 px-4 md:px-6">
            <button
              onClick={closeFilterSidebar}
              className="w-full rounded-sm bg-ui-darkest-grey py-3"
            >
              {resultsCount()}
            </button>
          </div>
        </motion.div>
      </div>
      <style jsx global>
        {`
          .ais-ClearRefinements .ais-ClearRefinements-button {
            text-decoration: underline;
          }
          .ais-ClearRefinements .ais-ClearRefinements-button--disabled {
            display: none;
          }
        `}
      </style>
    </motion.div>
  )
}
export default FilterSidebar
